import React from 'react';
import { Grid, Divider } from 'semantic-ui-react';
import styled from 'styled-components';
import { SectionLabelProps } from './types';

const LabelText = styled.p<{
  color?: string;
  compact?: boolean;
  paddingBottom?: number;
}>`
  font-weight: bold;
  color: ${props => props.color || '#364445'};
  ${props => props.compact && 'margin: 0;'}
  ${props =>
    props.paddingBottom !== undefined &&
    `padding-bottom: ${props.paddingBottom}px;`}
`;

const LabelColumn = styled(Grid.Column)<{ fullWidth?: boolean }>`
  padding: 0em 0em !important;
  ${props => props.fullWidth && 'width: 100% !important;'}
`;

const SectionLabel = (props: SectionLabelProps) => {
  return (
    <Grid.Row
      style={{
        paddingTop:
          props.paddingTop !== undefined ? `${props.paddingTop}px` : '0',
        paddingBottom:
          props.paddingBottom !== undefined ? `${props.paddingBottom}px` : '0',
        marginTop: props.marginTop ? `${props.marginTop}px` : '1.5em',
        color: props.color ? props.color : '#364445',
        width: props.fullWidth ? '100%' : undefined
      }}
    >
      <LabelColumn fullWidth={props.fullWidth}>
        <LabelText
          color={props.color}
          compact={props.compact}
          paddingBottom={props.labelPaddingBottom}
        >
          {props.text} {props.ReactItem && <props.ReactItem />}
        </LabelText>

        <Divider
          style={
            props.lineColor
              ? {
                  borderTop: `1px solid ${props.lineColor}`,
                  margin: 0
                }
              : undefined
          }
        />
      </LabelColumn>
    </Grid.Row>
  );
};

export default SectionLabel;
